import React from 'react';

export const SearchIcon = (props: any) => {
  return (
    <svg {...props} className="svg-icon">
      <svg id="icon-control-search" viewBox="0 0 1024 1024">
        <title>Search</title>
        <path
          className="path1"
          d="M240.939 484.159c0-113.541 88.33-212.799 201.654-222.040 118.436-9.658 218.452 81.9 218.452 204.919 0 123.003-100.016 222.72-218.452 222.72-113.324 0-201.654-92.037-201.654-205.599zM594.444 719.978c2.744 3.92 6.001 7.52 9.626 10.801l100.336 91.181c24.863 22.581 65.516 23.978 92.279 1.88 28.574-23.56 30.519-64.459 2.56-89.883l-111.313-101.097c33.993-48.562 54.17-107.463 54.17-170.959 0-166.060-137.683-289.681-300.696-276.644-155.984 12.481-277.565 146.461-277.565 299.762s121.582 277.561 277.565 277.561c55.439 0 107.885-15.52 153.039-42.602z"
        ></path>
      </svg>
    </svg>
  );
};
